<template>
<div class="container-fluid bg-white">
	<toolbar>
		<router-link to="/financial" class="btn btn-link">
			<i class="fa fa-caret-left fa-2x"></i>
			<h2>Financial</h2>
		</router-link>

		<div class="controls">
			<financial-nav-tabs></financial-nav-tabs>
		</div>
	</toolbar>

	<div>

		<table-list record-name="Project"
			:fields="[
				{label: 'Project', key: 'projectName',type:'link'},
				{label: 'Status', key: 'status'},
				{label: 'Holdback to Date', key: 'formattedHoldback', align:'right'},
				{label: 'Holdback Release to Date', key: 'formattedHoldbackRelease', align:'right'},
				{label: 'Holdback Outstanding', key: 'formattedOutstandingHoldback', align:'right'}
			]"
			:records="mutatedProjects">

			<h3>Project Holdbacks</h3>
		</table-list>
	</div>
	
</div>
</template>
<script type="text/javascript">
import Toolbar from "@/layout_fragments/Toolbar"
import FinancialNavTabs from "@/pages/financial/FinancialNavTabs"
import TableList from "@/components/TableList"

export default {
	name: "ProjectHoldbacks",
	components: {
		Toolbar,
		FinancialNavTabs,
		TableList
	},
	data() {
		return {
			projects: []
		}
	},
	computed: {
		mutatedProjects() {
			let vm = this

			let lines = this.projects.map(job => {
				job.projectName = {
					text: job.job_num + ": " + job.job_name,
					link: '/project/' + job.slug + "/billing"
				}
				job.formattedHoldback = job.total_holdback_to_date.toCurrency()

				job.formattedHoldbackRelease = job.total_holdback_release_to_date.toCurrency()

				let outstanding = +job.total_holdback_to_date - +job.total_holdback_release_to_date

				job.formattedOutstandingHoldback = outstanding.toCurrency()

				job.status = "Active"
				if (job.date_completed)
					job.status = "Completed"
				else if (job.archived == 1)
					job.status = 'Archived'

				return job
			})

			let totals = {
				projectName: "<strong>Totals</strong>",
				formattedHoldback: "<strong>" + this.projects.reduce((acc,job) => {
					let rounded = +job.total_holdback_to_date
					rounded = rounded.round(2)
					return acc + rounded
				},0).toCurrency() + "</strong>",
				formattedHoldbackRelease: "<strong>" + this.projects.reduce((acc,job) => {
					let rounded = +job.total_holdback_release_to_date
					rounded = rounded.round(2)
					return acc + rounded
				},0).toCurrency() + "</strong>",
				formattedOutstandingHoldback: "<strong>" + this.projects.reduce((acc,job) => {
					let rounded = +job.total_holdback_to_date - +job.total_holdback_release_to_date
					rounded = rounded.round(2)
					return acc + rounded
				},0).toCurrency() + "</strong>",
				tfoot: true,
			}

			lines.push(totals)

			return lines
		}
	},
	methods: {
		fetchHoldbacks() {
			let vm = this

			let params = {
				filters: [
					["total_holdback_to_date >",0]
				],
				orders: [
					["total_holdback_to_date","DESC"]
				]
			}

			this.getJSON("Job/get",params).then(response => {
				if (response.success) {
					vm.projects = response.data
				}
			})
		}
	},
	created() {
		this.fetchHoldbacks()
	}
}

</script>